;(function ($) {
  "use strict"
  $(function () {
    //begin of word__cal show/hide function

    $(document).on("click", ".word__cal", function () {
      let $currItem = $(this)
      if ($currItem.length !== 0) {
        $currItem.toggleClass("js-opened")
        $(document).find(".month_spec").toggleClass("js-open")
      }
    })
    //end of word__cal show/hide function

    function handlePos() {
      let $rack = $(".rack__rack_basket")
      let backetPopUp = $(".word")
      if (backetPopUp.find('[data-entity="basket-popup-item"]').length > 0) {
        let topPos = $rack.offset().top - 175
        let leftPos = $rack.offset().left + $rack.outerWidth() + 25
        backetPopUp.css("top", topPos)
        backetPopUp.css("left", leftPos)
      }
    }
    $(document).on("mouseenter", '[data-entity="basket-main-wrapper"]', function () {
      handlePos()
    })

    $(document).on("mouseleave", ".word", function () {
      $(".word").attr("style", "")
    })
    $(document).on("mouseleave", '[data-entity="basket-main-wrapper"]', function (e) {
      if (e.clientX < 230) {
        $(".word").attr("style", "")
      }
    })
    $(".rack").on("scroll", function () {
      $(".word").attr("style", "")
    })

    $(window).resize(function () {
      $(".word").attr("style", "")
    })
  })
})(jQuery)
